//Include Both Helper File with needed methods
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { base64toBlob, errorMessage } from "helpers/utils";
import { TYPE_AUTO_RELOAD } from "pages/IssueInvoice/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import ErrorInvoiceService from "services/ErrorInvoiceService";
import formatDataService from "services/FormatDataService";
import { backupDataNew } from "store/issue-invoice/actions";
import {
  createErrorInvoicesFail,
  createErrorInvoicesSuccess,
  downloadXmlErrorInvoicesFail,
  downloadXmlErrorInvoicesSuccess,
  editErrorInvoicesFail,
  editErrorInvoicesSuccess,
  errorInvoicesDeleteFail,
  errorInvoicesDeleteSuccess,
  getDetailErrorInvoicesFail,
  getDetailErrorInvoicesSuccess,
  getHistoryErrorTransferFail,
  getHistoryErrorTransferSuccess,
  getListErrorInvoicesFail,
  getListErrorInvoicesSuccess,
  listNotificationPropertiesErrorInvoicesFail,
  listNotificationPropertiesErrorInvoicesSuccess,
  listTypeInvoiceErrorInvoicesFail,
  listTypeInvoiceErrorInvoicesSuccess,
  previewPdfErrorInvoiceFail,
  previewPdfErrorInvoiceSuccess,
  releaseErrorInvoicesFail,
  releaseErrorInvoicesSuccess,
  searchInvoiceErrorInvoicesFail,
  searchInvoiceErrorInvoicesSuccess,
  transferUsbInvoiceErrorsFail,
  transferUsbInvoiceErrorsSuccess,
} from "./actions";
// Crypto Redux States
import {
  DOWNLOAD_XML_ERROR_INVOICES,
  ERROR_INVOICES_CREATE,
  ERROR_INVOICES_DELETE,
  ERROR_INVOICES_DETAIL,
  ERROR_INVOICES_EDIT,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST,
  ERROR_INVOICES_RELEASE,
  ERROR_INVOICES_SEARCH_INVOICE,
  ERROR_INVOICES_TYPE_INVOICE_LIST,
  GET_HISTORY_ERROR_ENVOICE_TRANSFER,
  GET_LIST_ERROR_INVOICES,
  PREVIEW_PDF_ERROR_INVOICE,
  TRANSFER_USB_ERROR_INVOICES,
} from "./actionTypes";
function* fetchGetHistoryTransfer({ id, path }) {
  try {
    const response = yield call(formatDataService.historyTransfer, id, path);
    if (response.items) {
      yield put(getHistoryErrorTransferSuccess(response.items));
    } else {
      yield put(getHistoryErrorTransferFail("GetHistoryTransfer Fail"));
    }
  } catch (error) {
    yield put(getHistoryErrorTransferFail(errorMessage(error)));
  }
}
function* fetchPreviewPdfErrorInvoice({ id, path, isTaxDeduct }) {
  try {
    // Call api
    const response = yield call(
      ErrorInvoiceService.reviewPdfErrorInvoice,
      id,
      path,
      isTaxDeduct
    );
    if (response.result && response.file) {
      const blob = base64toBlob(response.file);
      const url = URL.createObjectURL(blob);
      yield put(previewPdfErrorInvoiceSuccess(url));
    } else {
      yield put(previewPdfErrorInvoiceFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(previewPdfErrorInvoiceFail(errorMessage(error)));
  }
}
function* fetchGetErrorInvoices({ params, isInvoices }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const isTaxDeduct = params.isTaxDeduct || false;
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let { finalListBuCode, listBuOfTenant, buStoreHeader, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    let response = null;
    if (isInvoices) {
      // Hóa đơn sai sót
      response = yield call(
        ErrorInvoiceService.listInvoiceInvoiceErrors,
        page,
        perPage,
        columnFilter,
        keywords,
        sort,
        bu_code,
        bu_parent
      );
    } else {
      // Thông báo hóa đơn sai sót
      response = yield call(
        ErrorInvoiceService.listInvoiceErrors,
        page,
        perPage,
        columnFilter,
        keywords,
        sort,
        bu_code,
        bu_parent,
        isTaxDeduct
      );
    }
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListErrorInvoicesSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListErrorInvoicesFail(errorMessage(error)));
  }
}

function* fetchDownloadXml({
  resource_id,
  fileDownloadName,
  responseType = "blob",
  isTaxDeduct = false,
}) {
  try {
    const response = yield call(
      ErrorInvoiceService.downloadFileXML,
      resource_id,
      responseType,
      isTaxDeduct
    );
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);
          yield put(
            downloadXmlErrorInvoicesSuccess(
              null,
              file,
              fileDownloadName + ".xml"
            )
          );
        } else {
          yield put(downloadXmlErrorInvoicesFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlErrorInvoicesSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + ".xml"
          )
        );
      }
    } else {
      yield put(downloadXmlErrorInvoicesFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlErrorInvoicesFail("Download file thất bại"));
  }
}

function* onCreateErrorInvoices({ payload }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);

    const response = yield call(
      ErrorInvoiceService.createErrorInvoices,
      payload,
      buStoreHeader
    );
    yield put(createErrorInvoicesSuccess(response));
  } catch (error) {
    yield put(createErrorInvoicesFail(errorMessage(error)));
  }
}

function* onEditErrorInvoices({ payload, id }) {
  try {
    const response = yield call(
      ErrorInvoiceService.editErrorInvoices,
      payload.data,
      id
    );
    yield put(editErrorInvoicesSuccess(response));
  } catch (error) {
    yield put(editErrorInvoicesFail(errorMessage(error)));
  }
}

function sleep(sec) {
  return new Promise(resolve => setTimeout(resolve, sec * 1000));
}

function* onReleaseErrorInvoices({ id, isTaxDeduct }) {
  try {
    const response = yield call(
      ErrorInvoiceService.releaseErrorInvoices,
      id,
      isTaxDeduct
    );
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(
        backupDataNew({
          id,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_RELEASE_ERROR_INVOICE,
        })
      );
      yield put(releaseErrorInvoicesSuccess());
    } else {
      yield put(
        releaseErrorInvoicesFail("Gửi duyệt thông báo hóa đơn sat sót thất bại")
      );
    }
  } catch (error) {
    yield put(releaseErrorInvoicesFail(errorMessage(error)));
  }
}

function* onDeleteErrorInvoices({ id, isTaxDeduct }) {
  try {
    const response = yield call(
      ErrorInvoiceService.deleteErrorInvoices,
      id,
      isTaxDeduct
    );
    yield put(errorInvoicesDeleteSuccess());
  } catch (error) {
    yield put(errorInvoicesDeleteFail(errorMessage(error)));
  }
}

function* fetchSearchInvoiceErrorInvoices({ payload }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      ErrorInvoiceService.searchInvoiceErrorInvoices,
      payload,
      buStoreHeader
    );
    if (response) {
      yield put(searchInvoiceErrorInvoicesSuccess(response));
    } else {
      yield put(searchInvoiceErrorInvoicesFail({ status: "NOT_FOUND" }));
    }
  } catch (error) {
    yield put(searchInvoiceErrorInvoicesFail(errorMessage(error)));
  }
}

function* fetchListTypeInvoiceErrorInvoices({ payload }) {
  try {
    const response = yield call(
      ErrorInvoiceService.listTypeInvoiceErrorInvoices,
      payload
    );
    yield put(listTypeInvoiceErrorInvoicesSuccess(response));
  } catch (error) {
    yield put(listTypeInvoiceErrorInvoicesFail(errorMessage(error)));
  }
}

function* fetchListNotificationPropertiesErrorInvoices({ payload }) {
  try {
    const response = yield call(
      ErrorInvoiceService.listNotificationPropertiesErrorInvoices,
      payload
    );
    yield put(listNotificationPropertiesErrorInvoicesSuccess(response));
  } catch (error) {
    yield put(listNotificationPropertiesErrorInvoicesFail(errorMessage(error)));
  }
}

function* fetchTransferUsb({ id, typeSend, content }) {
  try {
    const data = {
      id,
      type: typeSend,
      content,
    };
    const response = yield call(ErrorInvoiceService.transfer, data);
    if (response.result) {
      yield sleep(1);
      yield put(transferUsbInvoiceErrorsSuccess());
    } else {
      yield put(transferUsbInvoiceErrorsFail(response?.error?.content));
    }
  } catch (error) {
    yield put(transferUsbInvoiceErrorsFail(errorMessage(error)));
  }
}

function* fetchDetailIssueInvoice({ id }) {
  try {
    let response = yield call(ErrorInvoiceService.detailInvoiceErrors, id);
    yield put(getDetailErrorInvoicesSuccess(response));
  } catch (error) {
    yield put(getDetailErrorInvoicesFail(errorMessage(error)));
  }
}

function* errorInvoicesSaga() {
  yield takeEvery(GET_HISTORY_ERROR_ENVOICE_TRANSFER, fetchGetHistoryTransfer);
  yield takeEvery(GET_LIST_ERROR_INVOICES, fetchGetErrorInvoices);
  yield takeEvery(ERROR_INVOICES_DETAIL, fetchDetailIssueInvoice);
  yield takeEvery(DOWNLOAD_XML_ERROR_INVOICES, fetchDownloadXml);
  yield takeEvery(ERROR_INVOICES_CREATE, onCreateErrorInvoices);
  yield takeEvery(ERROR_INVOICES_EDIT, onEditErrorInvoices);
  yield takeEvery(ERROR_INVOICES_RELEASE, onReleaseErrorInvoices);
  yield takeEvery(ERROR_INVOICES_DELETE, onDeleteErrorInvoices);

  yield takeEvery(
    ERROR_INVOICES_SEARCH_INVOICE,
    fetchSearchInvoiceErrorInvoices
  );
  yield takeEvery(
    ERROR_INVOICES_TYPE_INVOICE_LIST,
    fetchListTypeInvoiceErrorInvoices
  );
  yield takeEvery(
    ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST,
    fetchListNotificationPropertiesErrorInvoices
  );
  yield takeEvery(PREVIEW_PDF_ERROR_INVOICE, fetchPreviewPdfErrorInvoice);
  yield takeEvery(TRANSFER_USB_ERROR_INVOICES, fetchTransferUsb);
}

export default errorInvoicesSaga;
